import { Button } from "@/components/ui/button";

interface Props {
  codes: string[];
  onAcknowledge?: () => void;
}

/**
 * Muestra los 10 backup codes plaintext UNA vez (justo después del setup
 * o regenerate). Ofrece descargar como TXT para que el operador los
 * guarde fuera del navegador.
 *
 * Crítico para el flow: si el operador no guarda los códigos y pierde el
 * dispositivo del autenticador, queda bloqueado del sistema y necesita
 * intervención del admin con SQL directo.
 */
export function BackupCodesDisplay({ codes, onAcknowledge }: Props) {
  function downloadAsTxt() {
    const header = "AROC — códigos de respaldo 2FA\n\n";
    const body = codes.map((c, i) => `${i + 1}. ${c}`).join("\n");
    const footer = (
      "\n\nUsa cada código una sola vez si pierdes tu autenticador.\n" +
      "Estos códigos NO se vuelven a mostrar. Guárdalos en un lugar seguro."
    );
    const text = header + body + footer;
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "aroc-backup-codes.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  return (
    <div className="space-y-4">
      <div className="rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-900 dark:bg-amber-950/30 dark:border-amber-900 dark:text-amber-200">
        <strong>Importante:</strong> guarda estos 10 códigos. Solo se muestran una vez.
        Si pierdes tu dispositivo, los necesitas para volver a entrar.
      </div>
      <ul
        aria-label="Códigos de respaldo"
        className="grid grid-cols-2 gap-2 font-mono text-sm"
      >
        {codes.map((code, idx) => (
          <li
            key={code}
            className="rounded-md border border-border bg-muted/50 px-3 py-2 select-all"
          >
            <span className="text-muted-foreground mr-2">{idx + 1}.</span>
            {code}
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={downloadAsTxt}>
          Descargar como TXT
        </Button>
        {onAcknowledge && (
          <Button type="button" onClick={onAcknowledge}>
            Ya los guardé
          </Button>
        )}
      </div>
    </div>
  );
}
